module.exports = __webpack_public_path__ + "img/pinata-banner-b.f3f2aed9.jpg";